module.exports = __webpack_public_path__ + "static/media/insect(17).3a587e84.PNG";